var RobotInstanceScheduleMode;
(function (RobotInstanceScheduleMode) {
    RobotInstanceScheduleMode["weekly"] = "weekly";
    RobotInstanceScheduleMode["monthly"] = "monthly";
    RobotInstanceScheduleMode["specific"] = "specific";
})(RobotInstanceScheduleMode || (RobotInstanceScheduleMode = {}));
export default RobotInstanceScheduleMode;
